import(/* webpackMode: "eager", webpackExports: ["ContestPageClient"] */ "/vercel/path0/features/contests/components/ContestPageClient.tsx");
